export enum EArticleContentName {
  BROWSER_LINK = 'BrowserLink',
  EXPAND_PANEL = 'ExpandPanel',
}
